import { configs } from "@/_shared/constants";
import Quagga from "quagga";

export const useBarcodeWebcam = {
  computed: {
    webcamWasEnabled() {
      return !!(this.readerWasRunned && this.selectedMode === "webcam");
    },
  },
  methods: {
    startWebcam() {
      this.webcamIsRunning = true;
      this.readerWasRunned = true;
      this.selectedMode = "webcam";
      const configInstance = configs.quagga;
      configInstance.inputStream.target = document.querySelector("#reader");
      Quagga.init(configInstance, () => {
        Quagga.start();
        this.webcamIsRunning = false;
      });
      Quagga.onDetected((results) => {
        const { codeResult } = results[0];
        this.detectedBarcode = codeResult.code;
      });
    },
    stopWebcam() {
      if (this.webcamWasEnabled) {
        Quagga.stop();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/stock/mixins/useBarcodeWebcam.js